export enum ActionsEnum {
    CREATE = 'Create',
    DELETE = 'Delete',
    VIEW = 'View'
}